import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import SearchFilter from '@ui/components/Button/SearchFilter';
import { Box, Button, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import BDrawer from '@ui/components/common/BDrawer';
import { PrimaryGrid } from '@ui/components/common/Grid';
const AssignPickupLocationCoordinatorDialog = ({ open, onClose, rows, onAssignCoordinator, loading = false, searchValue, onSearchChange }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const columns = useMemo(() => [
        {
            field: 'name',
            headerName: t('labels.name'),
            flex: 1.2,
            minWidth: 170,
            sortable: false
        },
        {
            field: 'company',
            headerName: t('labels.company'),
            flex: 1,
            minWidth: 130,
            sortable: false,
            renderCell: (params) => (_jsx(Typography, { variant: 'body2', noWrap: true, style: { overflow: 'hidden', textOverflow: 'ellipsis' }, children: params.row.company || '-' }))
        },
        {
            field: 'type',
            headerName: t('common.type'),
            flex: 0.9,
            minWidth: 110,
            sortable: false,
            renderCell: (params) => (_jsx(Typography, { variant: 'body2', noWrap: true, style: { overflow: 'hidden', textOverflow: 'ellipsis' }, children: params.row.type || '-' }))
        },
        {
            field: 'primaryPerson',
            headerName: t('events.eventDetails.transportTab.primaryPerson'),
            flex: 1,
            minWidth: 140,
            sortable: false
        },
        {
            field: 'registered',
            headerName: t('events.eventDetails.transportTab.registered'),
            flex: 1,
            minWidth: 130,
            sortable: false
        },
        {
            field: 'actions',
            headerName: '',
            flex: 1.3,
            minWidth: 180,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const row = params.row;
                return (_jsx(Button, { variant: 'outlined', size: 'small', color: 'primary', onClick: (event) => {
                        event.stopPropagation();
                        onAssignCoordinator(row.id);
                    }, children: t('events.eventDetails.transportTab.assignAsCoordinator') }));
            }
        }
    ], [t, onAssignCoordinator]);
    const content = (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 2, children: [_jsx(Box, { sx: {
                    '& .MuiTextField-root': { bgcolor: 'transparent' },
                    '& .MuiOutlinedInput-root': {
                        bgcolor: theme.palette.common.grey8,
                        borderRadius: '16px'
                    }
                }, children: _jsx(SearchFilter, { fullWidth: true, forceDesktopVariant: true, searchValue: searchValue, onSearchChange: onSearchChange, placeholder: t('events.eventDetails.transportTab.searchAttendees'), breakpoint: 'lg', onClear: () => onSearchChange(''), widthBox: '100%', bgVariant: 'grey8' }) }), loading && (_jsx(Box, { display: 'flex', justifyContent: 'center', py: 4, children: _jsx(CircularProgress, { size: 32 }) })), !loading && (_jsx(PrimaryGrid, { columns: columns, rows: rows, showHeaderControls: false, showNewHeaderControls: false, noRowsText: t('labels.noOptions'), maxHeight: '360px' }))] }));
    const actions = (_jsx(Box, { width: '100%', children: _jsx(Button, { variant: 'outlined', color: 'inherit', size: 'large', onClick: onClose, fullWidth: true, children: t('actions.close') }) }));
    if (isSmallScreen) {
        return (_jsx(BDrawer, { open: open, onClose: onClose, title: t('events.eventDetails.transportTab.assignCoordinator'), anchor: 'bottom', showBottomBar: true, dialogActions: actions, children: _jsx(Box, { sx: { p: 2 }, children: content }) }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: onClose, titleWithIcon: t('events.eventDetails.transportTab.assignCoordinator'), titleIcon: '/assets/images/add-person.png', maxWidth: 'md', backgroundVariant: 'white', closeIcon: true, actions: actions, children: _jsx(Box, { p: 1.5, children: content }) }));
};
export default AssignPickupLocationCoordinatorDialog;
